import { ChevronLeft, ChevronRight } from '@piiqtechnologies/svg-icons';
import React from 'react';
import { PeekStack } from './PeekStack.js';
import { PeekTypography } from './PeekTypography.js';
import { PeekIconButton } from './PeekIconButton.js';
import { useTheme } from '@mui/material';
import { PeekDivider } from './PeekDivider.js';

const PeekTablePagination = ({ count, page, onChange }) => {
    const theme = useTheme();
    return (React.createElement(PeekStack, { direction: "row", px: 0.5, alignItems: "center", sx: { border: `0.5px ${theme.palette.grey[100]} solid`, borderRadius: theme.spacing(1) } },
        React.createElement(PeekIconButton, { onClick: (e) => onChange(e, page - 1), disabled: page <= 1, bordered: false },
            React.createElement(ChevronLeft, null)),
        React.createElement(PeekDivider, { sx: { mr: 1, borderColor: theme.palette.grey[100], height: "60%" }, orientation: "vertical" }),
        React.createElement(PeekTypography, { fontWeight: "fontWeightMedium" },
            page,
            "/",
            count),
        React.createElement(PeekDivider, { sx: { ml: 1, borderColor: theme.palette.grey[100], height: "60%" }, orientation: "vertical" }),
        React.createElement(PeekIconButton, { onClick: (e) => onChange(e, page + 1), disabled: page >= count, bordered: false },
            React.createElement(ChevronRight, null))));
};

export { PeekTablePagination, PeekTablePagination as default };
